import React from "react";
import { Tabs } from "antd";
import AccountNewInvoicing from "../AccountNewInvoicing/AccountNewInvoicing";
import AccountInvoicingAmount from "../AccountInvoicingAmount/AccountInvoicingAmount";
import "./AccountInvoicingTabs.less";

const { TabPane } = Tabs;

export default function AccountInvoicingTabs({
  toggleServicesIncludePastDates,
  isServicesIncludePastDates,
}) {
  return (
    <Tabs className="invoicing-tabs">
      <TabPane tab="По тарифу" key="1">
        <AccountNewInvoicing
          toggleServicesIncludePastDates={toggleServicesIncludePastDates}
          isServicesIncludePastDates={isServicesIncludePastDates}
        />
      </TabPane>
      <TabPane tab="На произвольную сумму" key="2">
        <AccountInvoicingAmount
          toggleServicesIncludePastDates={toggleServicesIncludePastDates}
          isServicesIncludePastDates={isServicesIncludePastDates}
        />
      </TabPane>
    </Tabs>
  );
}
